// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"90969982","151":"a91f359e","453":"9b41687b","537":"90fcffa6","613":"a11451ce","850":"c43ef0b9"}[chunkId] + ".chunk.js";
};